<template>
      <v-dialog
        transition="dialog-bottom-transition"
        :max-width="custumWidth"
        :value="value"
        persistent
      >
          <v-card>
            <v-toolbar v-if="enableFlashTypeMsg"
             :color="flashType" dark>{{ textByColor }}</v-toolbar>
            <v-card-text class="pa-0 pl-4 pt-5">
              <slot name="customsLabelOrInfo"/>
            </v-card-text>
            <v-card-actions class="justify-end">
              <slot name="customsButtonsForPopUp"/>
            </v-card-actions>
          </v-card>
      </v-dialog>
</template>

<script>
import '../../../assets/style.css';
import { isEnter } from '../../../util/shared/vue-global';

export default {
  name: 'CommonPopUp',
  data() {
    return {
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    custumWidth: {
      type: Number,
      default: 600,
    },
    enableFlashTypeMsg: {
      type: Boolean,
      default: true,
    },
    flashType: {
      type: String,
      default: 'info', // info, warning, error
    },
  },
  created() {
    window.addEventListener('keydown', this.handleSelShortCut);
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleSelShortCut);
  },
  computed: {
    textByColor() {
      if (this.flashType === 'info') return 'Info !';
      if (this.flashType === 'warning') return 'Warning !';
      if (this.flashType === 'error') return 'Error !';
      return '';
    },
    backColor() {
      if (this.flashType === 'info') return 'primary';
      if (this.flashType === 'warning') return 'amber accent-4';
      if (this.flashType === 'error') return 'red';
      return '';
    },
  },
  methods: {
    handleSelShortCut(e) {
      const isItEnter = isEnter(e);
      if (isItEnter) this.$emit('onEnter');
    },
  },
};
</script>
